<script>

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';

import PlaylistTable from '@/components/Playlist/PlaylistTable.vue';
import playlistService from '@/services/VideoContent/playlistService';

import {vueTopprogress} from 'vue-top-progress';
import {DoubleBounce} from 'vue-loading-spinner';

const tableColumns = ['Nome'];

export default {
  components: {
    PlaylistTable,
    vueTopprogress,
    DoubleBounce,
    quillEditor,
  },
  data() {
    return {
      table: {
        title: 'Playlists',
        columns: [...tableColumns],
      },
      isLoading: true,
      playlists: []
    };
  },
  mounted() {
    this.getPlaylists();
  },
  methods: {
    async getPlaylists() {
      try {
        this.playlists = await playlistService.getAll();
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deletePlaylist(preDeletedItem) {
      try {
        await playlistService.delete(preDeletedItem.item.id);

        this.getPlaylists();

        this.$notify({
          title: 'Ok',
          message: 'Playlist foi removida com sucesso!',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });

        preDeletedItem = {};
      } catch (error) {
        this.$notify({
          title: 'Ooopss',
          message: error.message,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }
    },
  },
};
</script>

<template>
  <div class="users-list">
    <div class="row">
      <div class="col-12">
        <card
        :title="table.title"
        :addItems="true"
        :itemType="'Playlist'"
        :routerType="'admin-playlist'">

          <div class="table-responsive">
            <playlist-table
              :data="playlists"
              :columns="table.columns"
              :hasActions="false"
              thead-classes="text-primary"
              @deleteItem="deletePlaylist"
            ></playlist-table>

            <double-bounce v-if="isLoading"></double-bounce>
          </div>

        </card>
      </div>
    </div>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>
